import { types } from 'mobx-state-tree';

export const PassolutionEndpoints = types.model('PassolutionEndpoints', {
  entryConditions: types.optional(
    types.string,
    `travel-information/entry-conditions`,
  ),
  options: types.optional(types.string, 'travel-information/options'),
});
